<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocId"
      ref="list"
      unit="生产入库单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      :expand-all-row="true"
      :show-checkbox="true"
      @row-select="rowSelect"
      v-if="trendShow"
      urlHash="business/stock/productionshipping"
      :temp-params="tempParams"
      :queryParamsAppend="params"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="加工阶段" label-width="85px">
          <el-select v-model="params.ProcessingType" clearable>
            <el-option v-for="item in machiningStageList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <!-- 明细 -->
    <el-button v-if="show" type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin: 30px 0 10px 10px"> 明细项 </el-button>
    <el-table ref="multipleTable" :row-key="row => row.Prop" :data="tableData" v-if="show" stripe border>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData="tableColumns" tableType="生产入库单明细" />

    <!-- <el-table  border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;">
        <el-table-column prop="SourceNo" label="加工单号" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="100" align="left"></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="100" align="left"></el-table-column>
        <el-table-column prop="UnitName" label="计量单位" min-width="100" align="left"></el-table-column>
        <el-table-column prop="Quantity" label="数量" min-width="100" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Price" label="单价" min-width="100" align="right" v-if="canPrice"></el-table-column>
        <el-table-column prop="Amount" label="金额" min-width="100" align="right" v-if="canPrice">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.Amount) }}</span>
          </template>
        </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog from '@/components/common/customTableDialog/customTableDialog'

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require('@/api/stock/stInDoc').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      //加工类型
      machiningStageApi: require('@/api/ba/machiningStage').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      trendShow: true,
      tableData: [],
      params: {
        ProcessingType: null
      },
      machiningStageList: [
        // { "value": "注塑", "label": "注塑", "disabled": false },
        // { "value": "特殊加工", "label": "特殊加工", "disabled": false },
        // { "value": "配件装配", "label": "配件", "disabled": false },
        // { "value": "产品装配", "label": "装配", "disabled": false },
        // { "value": "产品组装", "label": "组合", "disabled": false }
      ],
      tempParams: {
        InType: 1
      },
      tableColumns: [],
      show: false
    }
  },
  activated() {
    this.getRouterInfo()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/productionshipping')
    }
  },
  created() {
    this.getMachiningStageList()
    this.sourceTypeApi.info('生产入库单').then(res => {
      this.tempParams.InType = res.SourceTypeId
    })
    this.getTableColumns()
  },
  methods: {
    getRouterInfo() {
      if (this.$router.history.current.params.InType) {
        let params = this.$router.history.current.params
        console.log('params', params)
        // this.tempParams = {
        //   InType: params.InType,
        //   WorkDocNo: params.WorkDocNo
        // }
        this.tempParams.InType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.InType
        }
        this.tempParams.WorkDocNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.WorkDocNo
        }

        //this.callApi(this.tempParams)
        this.$refs.list.getData()
        // this.params={}
      }
    },
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'Rate', 'Price']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PuQuantity', 'Amount', 'TaxAmount'].includes(prop)
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: '生产入库单明细' })
      this.tableColumns = []
      this.tableColumns = res.Data
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true
    },
    onSave() {
      this.getTableColumns()
      this.$message.success('保存成功')
    },
    getMachiningStageList() {
      this.machiningStageApi.list({ Status: 1 }).then(res => {
        res.Data.forEach(item => {
          this.machiningStageList.unshift({ value: item.Name, label: item.Name })
        })
      })
    },
    rowSelect(row) {
      this.show = true
      let id = row.DocId
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.tableData = res.Data.Products
        }
      })
    }
  }
}
</script>
